module.exports = __webpack_public_path__ + "img/waiter.8483d6e7.png";